// import {  EquipDataArrayCache, equipDataArrayCacheInstance } from "@/services/EquipDataArrayCache";
import { EquipDataCache, equipDataCacheInstance } from "@/services/EquipDataCache";
import { EquipOptions, equipOptionsInstance } from "@/models/EquipOptions";
import { devConfig, localConfig, prdConfig } from "@/models/auth/equipConfig";
import { EquipMsalClient, equipmsalinstance } from "@/services/auth/EquipMsalClient";
import { RebuildMsalProviders } from ".";

// if (!window.equipArrayCache) window.equipArrayCache = equipDataArrayCacheInstance;
if (!window.equipCache) window.equipCache = equipDataCacheInstance;
if (!window.equipOptions) window.equipOptions = equipOptionsInstance;
if (!window.equipMsal) window.equipMsal = equipmsalinstance;

const equipOptions: EquipOptions = window.equipOptions;
const equipCache: EquipDataCache = window.equipCache;
const equipMsal: EquipMsalClient = window.equipMsal;

function recalcWorkbookFull(): Promise<void> {
  return Excel.run(async (context) => {
    // If you want to rebuild the dependency tree as well, use FullRebuild
    context.application.calculate(Excel.CalculationType.fullRebuild);
    await context.sync();
  });
}

export function updateRibbonUI() {
  console.log("Updating ribbon UI");
  if (typeof Office.ribbon?.requestUpdate === "function") {
    Office.ribbon
      .requestUpdate({
        tabs: [
          {
            id: "Equip",
            groups: [
              {
                id: "Connectivity",
                controls: [
                  {
                    id: "GoOnlineButton",
                    enabled: !equipOptions.Online,
                  },
                  {
                    id: "GoOfflineButton",
                    enabled: equipOptions.Online,
                  },
                  {
                    id: "DirectModeButton",
                    enabled: equipOptions.CalculationMode != "DIRECT",
                  },
                  {
                    id: "BatchModeButton",
                    enabled: equipOptions.CalculationMode != "BATCH",
                  },
                  {
                    id: "RefreshButton",
                    enabled: true,
                  },
                ],
              },
            ],
          },
        ],
      })
      .then(() => {
        console.log("Ribbon update succeeded");
      })
      .catch((error) => {
        console.log("Ribbon update failed:", error);
      });
  }
}

/**
 * Shows a notification when the add-in command is executed.
 * @param {Office.AddinCommands.Event} event
 */
export async function goOffline(event: Office.AddinCommands.Event) {
  equipOptions.Online = false;
  await recalcWorkbookFull();

  updateRibbonUI();
  event.completed();
  console.log(`ONLINE: ${equipOptions.Online}`);
}

/**
 * Shows a notification when the add-in command is executed.
 * @param {Office.AddinCommands.Event} event
 */
export async function goOnline(event: Office.AddinCommands.Event) {
  equipOptions.Online = true;
  await recalcWorkbookFull();

  updateRibbonUI();
  event.completed();
  console.log(`ONLINE: ${equipOptions.Online}`);
}

/**
 * Shows a notification when the add-in command is executed.
 * @param {Office.AddinCommands.Event} event
 */
export async function doFullRefresh(event: Office.AddinCommands.Event) {
  equipCache.ExpireCache();
  // clear requests, will be filled with valid requests via the public Get on the cache
  // DO NOT CLEAR REQUEST MAP BEFORE CACHE!! Will wipe entire cache
  equipCache.ExpireRequestMap();
  await equipCache.RehydrateCache();
  await recalcWorkbookFull();
  // await equipArrayCache.RehydrateCache();

  updateRibbonUI();
  event.completed();
  console.log(`FULL REFRESH`);
}

/**
 * Shows a notification when the add-in command is executed.
 * @param {Office.AddinCommands.Event} event
 */
export function goDirect(event: Office.AddinCommands.Event) {
  equipOptions.CalculationMode = "DIRECT";
  equipCache.StopCache();

  updateRibbonUI();
  event.completed();
  console.log(`MODE: ${equipOptions.CalculationMode}`);
}

/**
 * Enables batch mode on equip functions
 * @param {Office.AddinCommands.Event} event
 */
export function goBatchMode(event: Office.AddinCommands.Event) {
  equipOptions.CalculationMode = "BATCH";

  updateRibbonUI();
  event.completed();
  console.log(`MODE: ${equipOptions.CalculationMode}`);
}

/**
 * Activates local environment
 * @param {Office.AddinCommands.Event} event
 */
export async function localMode(event: Office.AddinCommands.Event) {
  await equipMsal.RegenerateClient(localConfig);
  RebuildMsalProviders();
  updateRibbonUI();
  event.completed();
  console.log(`APIENV: LOCAL`);
}

/**
 * Activates dev environment
 * @param {Office.AddinCommands.Event} event
 */
export async function devMode(event: Office.AddinCommands.Event) {
  await equipMsal.RegenerateClient(devConfig);
  RebuildMsalProviders();
  updateRibbonUI();
  event.completed();
  console.log(`APIENV: DEV`);
}

/**
 * Activates prod environment
 * @param {Office.AddinCommands.Event} event
 */
export async function prdMode(event: Office.AddinCommands.Event) {
  await equipMsal.RegenerateClient(prdConfig);
  RebuildMsalProviders();
  updateRibbonUI();
  event.completed();
  console.log(`APIENV: PRD`);
}

Office.actions.associate("goOffline", goOffline);
Office.actions.associate("goOnline", goOnline);
Office.actions.associate("doFullRefresh", doFullRefresh);
Office.actions.associate("goDirect", goDirect);
Office.actions.associate("goBatchMode", goBatchMode);
Office.actions.associate("localMode", localMode);
Office.actions.associate("devMode", devMode);
Office.actions.associate("prdMode", prdMode);
